import { Result } from "antd";

type ErrorProps = {
  title: string;
  subTitle?: string;
  extra?: React.ReactNode;
};

const ErrorToDisplay: React.FC<ErrorProps> = ({ title, subTitle, extra }) => {
  return (
    <div className="center-content">
      <Result status="warning" title={title} subTitle={subTitle} extra={extra} />
    </div>
  );
};

export default ErrorToDisplay;
